import {useInfiniteQuery} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  filter?: {
    cameraId: number
  }
  to?: string
  from?: string
}

export default function useCameraHistory({filter, to, from}: Props) {
  const {enqueueSnackbar} = useSnackbar()

  const query = useInfiniteQuery({
    retry: 0,
    refetchOnWindowFocus: true,
    initialPageParam: 1,
    queryKey: [QueryKeyEnum.CAMERA_HISTORY, filter, to, from],
    queryFn: async ({pageParam: nextPage}) => {
      if (nextPage === -1) throw new Error('No more page to load')

      const response = await api.camera.getCameraHistoric({
        page: nextPage,
        pageSize: 20,
        from,
        to,
        filter,
      })

      return response.data.data
    },
    getNextPageParam: (lastPage) => {
      const current = lastPage.currentPage
      if (lastPage.entities.length < 20) return -1
      return current + 1
    },
    throwOnError: () => {
      enqueueSnackbar('Todas as informações já foram carregadas', {variant: 'info'})
      return false
    },
  })

  return query
}
